angular.module('gym.payouts', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.payouts', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.payouts.list', {
    url: '/payouts',
    controller: 'PayoutsCtrl',
    template: require('templates/gyms/payouts/list.html.slim')
  }).state('gym.payouts.payout_items', {
    url: '/payouts/:payout_id/payout_items',
    controller: 'PayoutItemsCtrl',
    template: require('templates/gyms/payouts/payout_items.html.slim'),
    resolve: {
      payout: ["$stateParams", "Payouts", function($stateParams, Payouts) {
        return Payouts.get($stateParams.payout_id);
      }]
    }
  });
}]);
